import React, { PureComponent, Fragment } from 'react';
import Autosuggest from 'react-autosuggest';
import { location } from 'controllers/taxonomies';
import {
  Button,
  Grid,
  Typography,
  Box,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';

class OnboardingStep2 extends PureComponent {
  constructor() {
    super();
    this.state = {
      suggestions: [],
    };
  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.getSuggestions(value);
  };

  getSuggestions = async (value) => {
    const suggestions = await location(value);

    this.setState({
      suggestions: suggestions.response,
    });

    return suggestions.response;
  };

  renderSuggestion = (suggestion) => (
    <div>
      {suggestion.name}, {suggestion.country}
    </div>
  );

  getSuggestionValue = (suggestion) =>
    `${suggestion.name}, ${suggestion.country}`;

  render() {
    const { suggestions } = this.state;
    const {
      onCLickNext,
      onChange,
      linkedinLink,
      websiteLink,
      aboutCompany,
      companySize,
      foundedYear,
      location,
    } = this.props;

    const inputProps = {
      placeholder: 'Enter location',
      value: location,
      name: 'location',
      onChange,
    };

    return (
      <Fragment>
        <Typography variant="h4" className="heading">
          About your company
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              name="foundedYear"
              id="outlined-name"
              label="Founded In"
              margin="normal"
              variant="outlined"
              placeholder="when did you form"
              onChange={onChange}
              value={foundedYear}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl
              variant="outlined"
              style={{
                display: 'flex',
                marginTop: '16px',
              }}
            >
              <InputLabel
                htmlFor="outlined-age-simple"
                style={{
                  background: '#fff',
                  padding: '0 5px',
                }}
              >
                Company size
              </InputLabel>
              <Select
                name="companySize"
                value={companySize}
                onChange={onChange}
                input={
                  <OutlinedInput
                    name="Company size"
                    placeholder="Size of your company"
                    id="outlined-age-simple"
                  />
                }
              >
                <MenuItem value={'<10'}>{'<10'}</MenuItem>
                <MenuItem value={'10-50'}>10-50</MenuItem>
                <MenuItem value={'50-100'}>50-100</MenuItem>
                <MenuItem value={'100-200'}>100-200</MenuItem>
                <MenuItem value={'200-300'}>200-300</MenuItem>
                <MenuItem value={'300+'}>300+</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Autosuggest
              suggestions={suggestions}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
              getSuggestionValue={this.getSuggestionValue}
              renderSuggestion={this.renderSuggestion}
              inputProps={inputProps}
            />
          </Grid>
        </Grid>
        <Box marginTop="10px">
          <Typography variant="subtitle2">
            About the company (Let the story inspire someone today)
          </Typography>
        </Box>
        <TextField
          id="outlined-name"
          margin="normal"
          variant="outlined"
          fullWidth
          multiline
          rows="4"
          onChange={onChange}
          value={aboutCompany}
          name="aboutCompany"
        />
        <Box marginTop="10px">
          <Typography variant="subtitle2">
            Tell people where they can stalk you
          </Typography>
        </Box>
        <TextField
          id="outlined-name"
          label="Website"
          margin="normal"
          variant="outlined"
          fullWidth
          onChange={onChange}
          value={websiteLink}
          name="websiteLink"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton edge="start" aria-label="Search">
                  <Search />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          id="outlined-name"
          label="Linked In"
          margin="normal"
          variant="outlined"
          fullWidth
          onChange={onChange}
          name="linkedinLink"
          value={linkedinLink}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton edge="start" aria-label="Search">
                  <Search />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Grid
          container
          direction="row"
          justify="flex-end"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={5}>
            <Box marginTop="20px">
              <Button
                variant="outlined"
                color="default"
                fullWidth
                size="large"
                onClick={onCLickNext(1)}
              >
                Back
              </Button>
            </Box>
          </Grid>
          <Grid item xs={5}>
            <Box marginTop="20px">
              <Button
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                onClick={onCLickNext(3)}
              >
                Next
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

export default OnboardingStep2;
